import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from 'react-datepicker/dist/react-datepicker.css';

import { DB_DATE_FORMAT } from '../../util';

class DatePicker extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    }).isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.shape({
        id: PropTypes.string,
      }),
      warning: PropTypes.bool,
    }).isRequired,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    placeholder: '',
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    if (moment(date, DB_DATE_FORMAT).isValid()) {
      this.props.input.onChange(moment(date, DB_DATE_FORMAT));
    } else {
      this.props.input.onChange('');
    }
  }

  render() {
    const {
      input,
      placeholder,
      meta: { touched, error, warning },
      ...rest
    } = this.props;
    return (
      <div>
        <ReactDatePicker
          {...rest}
          className="form-control"
          placeholder={placeholder}
          dateFormat="DD.MM.YYYY"
          selected={input.value ? moment(input.value, 'DD.MM.YYYY') : moment()}
          onChange={this.handleChange}
        />
        {touched &&
          ((error && <p className="bg-danger">{error}</p>) ||
            (warning && <p className="bg-warning">{warning}</p>))}
      </div>
    );
  }
}

export default withStyles(s)(DatePicker);
